import React, { useState } from 'react'
import { TextInput, Button, Flex, Box, Grid, Stack, Text, Title, Card, Divider, ActionIcon, Modal, UnstyledButton } from '@mantine/core'
import { IconTrash } from '@tabler/icons-react'
import logos from './Logos'
import styled from "styled-components";
import actionList from './actionList'
import EntityActionAssociatorForm from './EntityActionAssociatorForm'
import EventList from './EventList'

export default function EntityActionLibrary({ onItemSubmit = () => { }, events = [], setEvents = () => { } }) {
  const [selectedAction, setSelectedAction] = useState(null);

  const scopedEvents = events.filter(event => event.action_id === selectedAction?.id);

  function onScopedEventsChange(newEvents) {
    setEvents([...events].filter((f) => {
      if (f.action_id === selectedAction?.id) {
        return newEvents.some(event => event.id === f.id);
      } else {
        return true;
      }
    }))
  }

  return (
    <div>
      <Text mb="xs" fw={600}>View and manage events based on actions</Text>
      <Grid>
        <Grid.Col span={{ base: 12, md: 3 }}>
          <Card>
            <Stack gap="xs">
              {actionList.map((action) => (
                <ActionItem key={action.id} action={action} isActive={selectedAction?.id === action.id} onClick={() => setSelectedAction(action === selectedAction ? null : action)} />
              ))}
            </Stack>
          </Card>
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 8 }}>
          <Card>
            {selectedAction && <div>
              <Box mb="md">
                <Text mb="xs" fw={600}>{selectedAction?.name}</Text>
                <Box p="xs" style={{
                  borderRadius: "var(--mantine-radius-md)",
                  border: "1px solid var(--mantine-color-gray-3)",
                  backgroundColor: "var(--mantine-color-yellow-0)"
                }}>
                  <Text size="sm">{selectedAction?.description}</Text>
                </Box>
              </Box>
              {scopedEvents.length > 0 && <>
                <Divider opacity={0.8} my="md" />
                <EventList events={scopedEvents} setEvents={(newEvents) => onScopedEventsChange(newEvents)} />
                <Divider opacity={0.8} my="md" />
              </>}
              <Box p="xs" style={{
                borderRadius: "var(--mantine-radius-md)",
                border: "1px solid var(--mantine-color-gray-3)",
                backgroundColor: "var(--mantine-color-gray-0)"
              }}>
                <Text mb="xs" size="sm" fw={600}>Add a new {selectedAction?.name} event</Text>
                <EntityActionAssociatorForm onItemSubmit={(item) => {
                  onItemSubmit(item)
                }} providerInfo={null} actionId={selectedAction?.id} />
              </Box>
            </div>}
            {!selectedAction && <Text size="sm" c="dimmed">Select an action to view more details</Text>}
          </Card>
        </Grid.Col>
      </Grid>
    </div>
  )
}

const ActionItem = ({ action, isActive, onClick = () => { } }) => {
  return (
    <UnstyledButton onClick={onClick}>
      <Box p="xs" style={{
        borderRadius: "var(--mantine-radius-md)",
        border: isActive ? `1px solid var(--mantine-color-blue-5)` : "1px solid var(--mantine-color-gray-3)",
        backgroundColor: isActive ? `var(--mantine-color-blue-0)` : "var(--mantine-color-gray-0)"
      }}>
        <Text size="sm" fw={600}>{action.name}</Text>
        {/* <Text size="xs">{action.description}</Text> */}
      </Box>
    </UnstyledButton>
  )
}